import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ObjectTypeEnum } from '@toro/common/shared/enum/my-investiments/object-type-enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';
import { AveragePriceAction } from '@toro/common/shared/state-management/average-price/average-price.action';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'groupment-card-dialog',
  templateUrl: './groupment-card-modal.component.html',
  styleUrls: ['./groupment-card-modal.component.scss'],
})
export class GroupmentCardModalComponent extends DialogComponentContent {
  public libMath = Math;
  public investType: any = ObjectTypeEnum;
  public toolTipPositionResult = 'O <strong>resultado das posições</strong> calcula a soma de todos os resultados referentes a este ativo.';
  public symbolQuote: number = 0;
  public quoteSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<GroupmentCardModalComponent>,
    private readonly store: Store<AppState>,

  ) {
    super(elementRef);
  }

  public ngOnInit() {
    this.store.dispatch({ type: AveragePriceAction.getCustodyAveragePrice });
    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.data.symbol});
    this.bindQuoteSubscription();
  }


public get getResult() {
  return (this.symbolQuote - this.data.averagePrice) * this.data.total;
}


public bindQuoteSubscription = () => {
  this.quoteSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
      .pipe(
          filter((item) => item[this.data.symbol]),
          map((item) => item[this.data.symbol])    
      )
      .subscribe((data) => {
          this.symbolQuote = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
      });
  }

  /**
   * Encerra o componente informando se há confirmação
   * @param confirm confirmação para realizar incrição ou cancelamento.
   */
  public closeDialog() {
    super.close(this.dialogReference, null);
  }
}
